<template>
  <div class="w-full flex flex-col online-shoping-container">
    <div class="">
      <div class="mb-4 font-bold text-xl">انتخاب خط</div>
      <div class="mb-4 text-center laptop:text-right">
        مشتری گرامی لطفا ابتدا کد استان خود را انتخاب و سپس در لیست شماره های
        نواتل، روی شماره مورد نظر کلیک نمایید.
      </div>
      <div
        class="mb-10 grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 justify-between gap-x-20 gap-y-16 text-center"
      >
        <select
          v-model="selectedNumberType"
          class="w-full rounded-lg border border-blue-700 px-4 py-2 h-[42px]"
          @change="changeSelectedType"
        >
          <option
            v-for="option in numberTypes"
            :key="option.value"
            :value="option.value"
            v-text="option.text"
          />
        </select>
        <select
          v-model="prefix"
          class="w-full rounded-lg border border-blue-700 px-4 py-2 h-[42px]"
        >
          <option
            v-for="option in city"
            :key="option.value"
            :selected="option.isSelected"
            :value="option.value"
            v-text="option.text"
          />
        </select>
        <div class="w-full relative flex">
          <input
            dir="ltr"
            v-model="searchedPhone"
            type="text"
            class="w-full rounded-lg border border-blue-700 px-4 pe-2 ps-12 h-[42px]"
          />
          <div
            class="h-full aspect-square bg-blue-700 absolute end-0 rounded-e-lg flex justify-center items-center text-white"
          >
            <IconSearch />
          </div>
        </div>
      </div>
    </div>
    <template
      v-if="foundNumber && Array.isArray(foundNumber) && foundNumber.length > 0"
    >
      <div class="font-semibold text-lg my-10"></div>
      <div
        class="mb-10 grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 justify-between gap-10 text-center"
      >
        <BasePhoneCard
          v-for="item in foundNumber"
          :key="item.id"
          :phone="item.phone"
          :price="item.price"
          :isSelected="form.didNo === item.id"
          :customClass="`bg-[${item.color}] border-[${item.color}]`"
          @click="selectPhoneNumber(item.id, item.phone, item.color)"
        />
        <div class="text-[#53832C] flex justify-center items-center">
          کاربر گرامی شماره موردنظر شما موجود می باشد.
        </div>
      </div>
    </template>
    <template
      v-else-if="
        similarNumbers &&
        Array.isArray(similarNumbers) &&
        similarNumbers.length > 0
      "
    >
      <div class="font-semibold text-lg my-10">لیست شماره های مشابه</div>
      <div
        class="mb-10 grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 justify-between gap-10 text-center"
      >
        <BasePhoneCard
          v-for="item in similarNumbers"
          :key="item.id"
          :phone="item.phone"
          :price="item.price"
          :isSelected="form.didNo === item.id"
          :customClass="`bg-[${item.color}] border-[${item.color}]`"
          @click="selectPhoneNumber(item.id, item.phone, item.color)"
        />
      </div>
    </template>
    <template v-else-if="searchCompleted && searchedPhone">
      <div
        class="text-red-500 mt-1 ms-1 h-16 font-bold flex justify-center items-center"
      >
        کاربر گرامی شماره موردنظر شما موجود نمی باشد.
      </div>
    </template>
    <div class="flex justify-between my-10">
      <div class="font-semibold text-lg">نمونه شماره های نواتلی</div>
      <div
        class="p-2 bg-white rounded-xl border border-blue-700 cursor-pointer"
        @click="refreshNumbers"
      >
        <IconRefresh />
      </div>
    </div>
    <div
      class="mb-10 grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-4 justify-between gap-x-20 gap-y-16 text-center"
    >
      <div class="justify-center">
        <div class="text-[#BA7A5D]">شماره های برنزی</div>
        <BasePhoneCard
          v-for="item in itemsOpal"
          :key="item.id"
          :phone="item.phone"
          :price="item.price"
          :isSelected="form.didNo === item.id"
          customClass="bg-[#BA7A5D] border-[#BA7A5D]"
          @click="selectPhoneNumber(item.id, item.phone, '#BA7A5D')"
        />
      </div>
      <div class="justify-center">
        <div class="text-[#8E8585]">شماره های نقره ای</div>
        <BasePhoneCard
          v-for="item in itemsNoghre"
          :key="item.id"
          :phone="item.phone"
          :price="item.price"
          :isSelected="form.didNo === item.id"
          customClass="bg-[#8E8585] border-[#8E8585]"
          @click="selectPhoneNumber(item.id, item.phone, '#8E8585')"
        />
      </div>
      <div class="justify-center">
        <div class="text-[#D4AF37]">شماره های طلایی</div>
        <BasePhoneCard
          v-for="item in itemsTala"
          :key="item.id"
          :phone="item.phone"
          :price="item.price"
          :isSelected="form.didNo === item.id"
          customClass="bg-[#D4AF37] border-[#D4AF37]"
          @click="selectPhoneNumber(item.id, item.phone, '#D4AF37')"
        />
      </div>
      <div
        class="w-full mt-12 laptop:mt-[57px] p-4 shadow-xl bg-white relative"
      >
        <div class="flex">
          <div class="pack" :class="targetPack.off ? '!w-[110px]' : ''">
            {{ targetPack.label }}
          </div>
          <div v-if="targetPack.off" class="off">
            <div>%{{ targetPack.off }}</div>
            <div class="-mt-2">OFF</div>
          </div>
        </div>
        <div class="text-sm text-center">{{ targetPack.title }}</div>
        <div class="flex flex-col items-center">
          <span
            v-if="targetPack.off_price"
            class="flex items-center justify-center mt-3 line-through"
          >
            <span class="text-base font-bold">{{ targetPack.price }}</span>
            <span>تومان</span>
          </span>
          <span
            class="flex items-center justify-center"
            :class="targetPack.off_price ? 'mb-3' : 'my-6'"
          >
            <span class="ml-1 text-2xl font-bold">{{
              targetPack.off_price ? targetPack.off_price : targetPack.price
            }}</span>
            <span>تومان</span>
          </span>
          <div class="text-sm mb-4">
            <div class="text-center">+</div>
            <div class="text-center">
              {{ targetPack.setupFee }}<span class="ms-1">تومان</span>
            </div>
            <div class="text-center">هزینه راه‌اندازی</div>
          </div>
        </div>
        <div class="w-full">
          <BaseButton
            id="oshop-selectBundle"
            isLean
            size="full"
            text="بسته انتخابی شما"
          />
        </div>
        <div class="flex flex-col my-4 gap-3">
          <div
            class="flex justify-start text-sm text-right"
            v-for="i in targetPack.options"
            :key="'bo' + i.id"
          >
            <div>
              <IconTik class="ml-1 w-2 fill-blue-700 mt-[2px]" />
            </div>
            <div>{{ i.title }}</div>
          </div>
        </div>
      </div>
      <div class="flex flex-col justify-start gap-2 h-[120px] -mx-10">
        <div class="font-semibold">تعداد کانال (همزمانی تماس):</div>
        <div dir="ltr" class="flex justify-center">
          <input
            v-model.number="form.ChannelQuantity"
            pattern="\d*"
            type="text"
            class="w-16 h-11 text-center rounded-md border border-blue-700"
            min="1"
            max="20"
            readonly
          />
        </div>
        <div
          v-if="channelQuantityError"
          class="text-red-500 text-xs text-start font-bold"
          v-text="channelQuantityError"
        />
        <div v-else class="text-xs font-light">
          *قیمت هر کانال {{ selectedNumberType == "8280" ? "240" : "100" }} هزار
          تومان
        </div>
      </div>
      <div
        class="flex flex-col col-span-2 justify-start gap-2 h-[120px] max-w-[300px]"
      >
        <div class="font-semibold">مبلغ اعتبار اولیه (تومان):</div>

        <input
          id="priceInput"
          autocomplete="off"
          pattern="\d*"
          type="text"
          placeholder="10,000 تومان"
          class="w-full h-11 px-4 rounded-md border border-blue-700"
          @input="setPriceFunction($event.target.value)"
          :value="price"
        />
        <div
          v-if="invalidInitialCredit"
          class="text-red-500 text-xs text-start font-bold"
        >
          {{ invalidInitialCreditText }}
        </div>
        <div v-else class="text-xs font-light text-start">
          *شارژ خط برای برقراری تماس‌های خروجی و دایورت
        </div>
      </div>
      <!-- <div></div> -->
      <div v-if="form.didNo" class="h-[100px] rounded-lg overflow-hidden">
        <div
          class="h-1/2 text-white flex justify-center items-center"
          :class="selectedPhoneNumberColor"
          v-text="'شماره انتخابی شما'"
        />
        <div
          class="h-1/2 bg-white flex justify-center items-center"
          v-text="selectedPhoneNumber"
        />
      </div>
      <div
        v-else-if="hasErrorRequireNumber"
        class="text-red-500 text-xs text-start font-bold flex justify-center items-center"
      >
        انتخاب شماره الزامی است
      </div>
    </div>
    <div
      class="flex justify-between mt-10 flex-col laptop:flex-row [&>*]:laptop:w-[45%] [&>*]:mb-4 [&>*]:laptop:mb-0"
    >
      <div class="w-full laptop:max-w-[20%]">
        <BaseButton
          styleType="secondary"
          isLean
          size="full"
          text="بازگشت به مرحله قبل"
          @click="goToPrevStep"
        >
          <IconArrowLeft class="ml-2 rotate-180 my-auto" />
        </BaseButton>
      </div>
      <div class="w-full laptop:max-w-[20%]">
        <BaseButton
          isLean
          size="full"
          text="تایید و ادامه"
          @click="acceptClicked"
          id="oshop-selectNumber"
        />
      </div>
    </div>
    <SectionModalCredit
      :isShow="isCreditModalShowed"
      @close="isCreditModalShowed = false"
      @confirm="goToNextStep"
    />
  </div>
</template>

<script setup>
const { getNumbers, searchNumber, setNumber, getBundles } = useOnlineShopping();

const emit = defineEmits(["goToNextStep", "goToPrevStep"]);

const isCreditModalShowed = ref(false);

const searchedPhone = ref("");
const searchCompleted = ref(false);
const prefix = ref("021");
const selectedPhoneNumber = useState("selectDidNo") || ref("");
const selectedPhoneNumberColor = useState("selectDidNoColor") || ref("#ddd");
const invalidInitialCredit = ref(false);
const invalidInitialCreditText = ref("");
const hasErrorRequireNumber = ref(false);
const channelQuantityError = ref("");
const selectedNumberType = ref("8280");

const targetPack = ref({});
const pack8280 = ref({});
const pack9169 = ref({});

const refreshNumbers = async () => {
  const { data, error } = await getNumbers({
    body: { prefix: prefix.value + selectedNumberType.value },
  });
  if (!error.value && data.value) {
    // const jsonData = JSON.parse(data.value.replace(/\\*/g, ""));
    const jsonData = toRaw(data.value);
    itemsTala.value = jsonData
      .find((el) => el.title === "Gold")
      .did.map((el) => {
        return {
          id: String(el.id),
          phone: el.number,
          price: `${(+el.price).toLocaleString()} تومان`,
        };
      });
    itemsNoghre.value = jsonData
      .find((el) => el.title === "Silver")
      .did.map((el) => {
        return {
          id: String(el.id),
          phone: el.number,
          price: `${(+el.price).toLocaleString()} تومان`,
        };
      });
    itemsOpal.value = jsonData
      .find((el) => el.title === "Bronze")
      .did.map((el) => {
        return {
          id: String(el.id),
          phone: el.number,
          price: `${(+el.price).toLocaleString()} تومان`,
        };
      });
  }
};

watch(
  () => prefix.value,
  async () => {
    refreshNumbers();
  },
  {
    immediate: true,
  }
);
watch(
  () => prefix.value,
  async (newVal) => {
    if (searchedPhone.value) {
      const { data, error } = await searchNumber({
        body: {
          prefix: newVal ? newVal + "9169" : "0009169",
          didNo: searchedPhone.value,
        },
      });
      if (!error.value && data.value) {
        // const jsonData = JSON.parse(data.value.replace(/\\*/g, ""))
        const jsonData = toRaw(data.value);
        similarNumbers.value = jsonData
          .find((el) => el.title === "Similar")
          .did.map((el) => {
            return {
              id: String(el.id),
              phone: el.number,
              price: `${(+el.price).toLocaleString()} تومان`,
              color: getColor(el.type),
            };
          });
        foundNumber.value = jsonData
          .find((el) => el.title === "Search")
          .did.map((el) => {
            return {
              id: String(el.id),
              phone: el.number,
              price: `${(+el.price).toLocaleString()} تومان`,
              color: getColor(el.type),
            };
          });
      }
    }
  }
);

watch(
  () => searchedPhone.value,
  async (newVal) => {
    if (newVal) {
      const { data, error } = await searchNumber({
        body: {
          prefix: prefix.value ? prefix.value + "9169" : "0009169",
          didNo: newVal,
        },
      });
      if (!error.value && data.value) {
        // const jsonData = JSON.parse(data.value.replace(/\\*/g, ""))
        const jsonData = data.value;
        similarNumbers.value = jsonData
          .find((el) => el.title === "Similar")
          .did.map((el) => {
            return {
              id: String(el.id),
              phone: el.number,
              price: `${(+el.price).toLocaleString()} تومان`,
              color: getColor(el.type),
            };
          });
        foundNumber.value = jsonData
          .find((el) => el.title === "Search")
          .did.map((el) => {
            return {
              id: String(el.id),
              phone: el.number,
              price: `${(+el.price).toLocaleString()} تومان`,
              color: getColor(el.type),
            };
          });
        searchCompleted.value = true;
      }
    } else {
      similarNumbers.value = [];
      foundNumber.value = [];
      searchCompleted.value = false;
    }
  }
);

const getColor = (type) => {
  switch (type) {
    case "NavaTel_silver":
      return "#8E8585";
    case "NavaTel_opal":
      return "#BA7A5D";
    case "NavaTel_golden":
      return "#D4AF37";
    case "NavaTel_bronze":
      return "#BA7A5D";
    case "NavaDID_good":
      return "#06f";
    case "NavaDID_excellent":
      return "#06f";
    case "NavaDID":
      return "#BA7A5D";
    default:
      return "#06f";
  }
};

const form = reactive({
  didNo: useState("didNo").value || null,
  ChannelQuantity: useState("ChannelQuantity").value || 1,
  InitialCredit: useState("InitialCredit").value || null,
});

const itemsOpal = ref([]);

const itemsTala = ref([]);

const itemsNoghre = ref([]);

const similarNumbers = ref([]);

const foundNumber = ref([]);

const numberTypes = [
  { value: "8280", text: "پیش‌شماره 8280" },
  { value: "9169", text: "پیش‌شماره 9169" },
];
const options = [
  { value: "", text: "کد استان", isSelected: true },
  { value: "021", text: "تهران (021)" },
  { value: "031", text: "اصفهان (031)" },
  { value: "026", text: "البرز (026)" },
  { value: "071", text: "فارس (071)" },
  { value: "041", text: "آذربایجان شرقی (041)" },
  { value: "051", text: "خراسان رضوی (051)" },
  { value: "087", text: "کردستان (087)" },
  { value: "076", text: "هرمزگان (076)" },
];
const city = computed(() => {
  if (selectedNumberType.value === "8280") {
    return options.filter((item) => item.value == "021");
  } else {
    return options;
  }
});

const selectPhoneNumber = (selectedId, number, color) => {
  form.didNo = selectedId;
  selectedPhoneNumber.value = number;
  selectedPhoneNumberColor.value = `bg-[${color}]`;
};

const changeSelectedType = () => {
  targetPack.value =
    selectedNumberType.value == "8280" ? pack8280.value : pack9169.value;
  useState("BundleId").value = targetPack.value.id;
  useState("didNo").value = "";
  useState("selectDidNoColor").value = "";
  useState("selectDidNo").value = "";
  form.didNo = "";
  prefix.value = "021";

  refreshNumbers();
};

const updateChannelQuantity = (type) => {
  channelQuantityError.value = "";
  if (type == "plus") {
    if (useState("BundleId").value == 5) {
      channelQuantityError.value =
        "برای بسته تلفن اینترنتی تنها یک کانال مجاز است.";
    } else if (useState("user_type").value == 1) {
      if (form.ChannelQuantity < 2) {
        form.ChannelQuantity++;
      } else {
        channelQuantityError.value =
          "شما به عنوان شخص حقیقی حداکثر دو کانال می توانید تهیه کنید";
      }
    } else if (useState("user_type").value == 2) {
      if (form.ChannelQuantity < 4) {
        form.ChannelQuantity++;
      } else {
        channelQuantityError.value =
          "شما به عنوان شخص حقوقی حداکثر چهار کانال می توانید تهیه کنید";
      }
    }
  } else if (type == "minus" && form.ChannelQuantity > 1) {
    form.ChannelQuantity--;
  }
};
const price = ref();
function setPriceFunction(value) {
  let filtredPrice = value.replace(/[$,.]/g, "");
  filtredPrice = filtredPrice.replace(/[^0-9]/g, "");
  price.value = filtredPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  document.body.querySelector(".online-shoping-container #priceInput").value =
    filtredPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const acceptClicked = () => {
  form.InitialCredit = price.value?.replace(/[$,.]/g, "");
  invalidInitialCreditText.value = "";
  if (form.InitialCredit && form.InitialCredit < 10000) {
    invalidInitialCredit.value = true;
    invalidInitialCreditText.value = "حداقل اعتبار اولیه 10,000 تومان می‌باشد.";
  } else if (form.InitialCredit && form.InitialCredit > 100000000) {
    invalidInitialCredit.value = true;
    invalidInitialCreditText.value =
      "حداکثر اعتبار اولیه 100,000,000 تومان می‌باشد.";
  } else if (!form.didNo) {
    hasErrorRequireNumber.value = true;
  } else if (useState("BundleId").value == 5 && form.ChannelQuantity != 1) {
    channelQuantityError.value =
      "برای بسته تلفن اینترنتی تنها یک کانال مجاز است.";
  } else if (
    form.didNo &&
    form.ChannelQuantity &&
    form.InitialCredit &&
    form.InitialCredit > 0
  ) {
    goToNextStep();
  } else if (form.didNo && form.ChannelQuantity) {
    isCreditModalShowed.value = true;
  }
};

const goToNextStep = async () => {
  console.log(form, form.InitialCredit);
  if (!form.InitialCredit) {
    form.InitialCredit = 0;
  }
  useState("InitialCredit").value = form.InitialCredit;
  useState("ChannelQuantity").value = form.ChannelQuantity;
  useState("didNo").value = form.didNo;
  useState("selectDidNoColor").value = selectedPhoneNumberColor.value;
  useState("selectDidNo").value = selectedPhoneNumber.value;
  useState("selectedNumberType").value = selectedNumberType.value;
  const shoppingData = JSON.parse(localStorage.getItem("shoppingData")) || {};
  shoppingData.InitialCredit = form.InitialCredit;
  shoppingData.ChannelQuantity = form.ChannelQuantity;
  shoppingData.didNo = form.didNo;
  shoppingData.selectDidNoColor = form.selectDidNoColor;
  shoppingData.selectDidNo = form.selectDidNo;
  
  const { data, error } = await setNumber({ body: { ...form } });
  if (!error.value && data.value) {
    emit("goToNextStep");
  }
};
const goToPrevStep = () => {
  emit("goToPrevStep");
};

onBeforeMount(async () => {
  const { data, error } = await getBundles({
    body: {
      Campaign: "",
      BundleId: "5",
      type: "callcenter",
    },
  });
  if (!error.value && data.value) {
    let pack = toRaw(data.value).map((el) => {
      let price = el.bundleDetails[0].price.replaceAll("/", "");
      return {
        id: el.id,
        title: "سالیانه",
        label: el.title,
        order: el.ordering,
        isRecomended: el.isRecommend,
        price: el.bundleDetails[0].price,
        setupFee: el.bundleDetails[0].setupFee,
        options: el.bundleFeatures.map((feature) => {
          return {
            id: feature.id,
            title: feature.description,
            order: feature.ordering,
          };
        }),
        off: el.campaigns.length ? el.campaigns[0].discount : null,
        off_price:
          el.campaigns.length && el.campaigns[0].discount != 0
            ? (
                price -
                (price * el.campaigns[0].discount) / 100
              ).toLocaleString()
            : null,
      };
    });
    pack9169.value = pack[0];
  }
  const { data: data2, error: error2 } = await getBundles({
    body: {
      Campaign: "",
      BundleId: "23",
      type: "8280",
    },
  });
  if (!error2.value && data2.value) {
    let pack = toRaw(data2.value).map((el) => {
      let price = el.bundleDetails[0].price.replaceAll("/", "");
      return {
        id: el.id,
        title: "سالیانه",
        label: el.title,
        order: el.ordering,
        isRecomended: el.isRecommend,
        price: el.bundleDetails[0].price,
        setupFee: el.bundleDetails[0].setupFee,
        options: el.bundleFeatures.map((feature) => {
          return {
            id: feature.id,
            title: feature.description,
            order: feature.ordering,
          };
        }),
        off: el.campaigns.length ? el.campaigns[0].discount : null,
        off_price:
          el.campaigns.length && el.campaigns[0].discount != 0
            ? (
                price -
                (price * el.campaigns[0].discount) / 100
              ).toLocaleString()
            : null,
      };
    });
    pack8280.value = pack[0];
  }
  targetPack.value = pack8280.value;
  useState("BundleId").value = targetPack.value.id;
});
</script>
